import { baseFetch } from 'src/utils';
import type { MembershipStatus } from 'src/types';

export const removeUserAPI = async (
  id: string,
  email: string,
  status: MembershipStatus,
) => {
  const res = await baseFetch(`/api/org/users/remove`, {
    method: 'DELETE',
    body: JSON.stringify({ id, email, status }),
  });

  const data = await res.json();

  if (data && data.error === 'last_admin') {
    throw new Error('last_admin');
  }

  if (!res.ok) {
    throw new Error('Failed to remove user');
  }

  return true;
};
